export function initHotspots() {
  /**
   * Hotspot Display - Frontend JavaScript
   */

  (function() {
    'use strict';

    class HotspotDisplay {
      constructor(container) {
        this.container = container;
        this.dots = container.querySelectorAll('.hotspot-display__dot');
        this.tooltips = container.querySelectorAll('.hotspot-display__tooltip');
        this.activeTooltip = null;

        this.init();
      }

      init() {
        this.bindEvents();
        this.positionTooltips();

        // Reposition on resize
        window.addEventListener('resize', () => {
          this.debounce(() => this.positionTooltips(), 100);
        });
      }

      bindEvents() {
        // Dot clicks
        this.dots.forEach(dot => {
          dot.addEventListener('click', (e) => {
            e.stopPropagation();
            this.toggleTooltip(dot);
          });
        });

        // Close buttons
        this.tooltips.forEach(tooltip => {
          const closeBtn = tooltip.querySelector('.hotspot-display__tooltip-close');
          if (closeBtn) {
            closeBtn.addEventListener('click', (e) => {
              e.stopPropagation();
              this.closeAllTooltips();
            });
          }
        });

        // Close on outside click
        document.addEventListener('click', (e) => {
          if (!e.target.closest('.hotspot-display__tooltip') && 
            !e.target.closest('.hotspot-display__dot')) {
            this.closeAllTooltips();
          }
        });

        // Close on escape
        document.addEventListener('keydown', (e) => {
          if (e.key === 'Escape') {
            this.closeAllTooltips();
          }
        });
      }

      toggleTooltip(dot) {
        const index = dot.dataset.index;
        const tooltip = this.container.querySelector(`.hotspot-display__tooltip[data-index="${index}"]`);

        if (!tooltip) return;

        const isActive = tooltip.classList.contains('is-active');

        // Close all tooltips first
        this.closeAllTooltips();

        if (!isActive) {
          // Position and show this tooltip
          this.positionSingleTooltip(dot, tooltip);
          tooltip.classList.add('is-active');
          tooltip.setAttribute('aria-hidden', 'false');
          dot.setAttribute('aria-expanded', 'true');
          this.activeTooltip = tooltip;
        }
      }

      closeAllTooltips() {
        this.tooltips.forEach(tooltip => {
          tooltip.classList.remove('is-active');
          tooltip.setAttribute('aria-hidden', 'true');
        });

        this.dots.forEach(dot => {
          dot.setAttribute('aria-expanded', 'false');
        });

        this.activeTooltip = null;
      }

      positionTooltips() {
        this.dots.forEach(dot => {
          const index = dot.dataset.index;
          const tooltip = this.container.querySelector(`.hotspot-display__tooltip[data-index="${index}"]`);
          if (tooltip) {
            this.positionSingleTooltip(dot, tooltip);
          }
        });
      }

      positionSingleTooltip(dot, tooltip) {
        const containerRect = this.container.getBoundingClientRect();
        const dotRect = dot.getBoundingClientRect();

        // Get dot position relative to container
        const dotX = parseFloat(dot.style.left);
        const dotY = parseFloat(dot.style.top);

        // Position tooltip below dot by default
        tooltip.style.left = dotX + '%';
        tooltip.style.top = (dotY + 5) + '%';

        // Remove positioning classes
        tooltip.classList.remove('position-top');

        // Check if tooltip would go below viewport
        const tooltipRect = tooltip.getBoundingClientRect();
        const spaceBelow = window.innerHeight - dotRect.bottom;

        if (spaceBelow < tooltipRect.height + 20) {
          // Position above
          tooltip.classList.add('position-top');
          tooltip.style.top = dotY + '%';
        }

        // Adjust horizontal position if needed
        const containerWidth = containerRect.width;
        const tooltipWidth = tooltip.offsetWidth;
        const dotCenterX = containerWidth * (dotX / 100);

        // Check left edge
        if (dotCenterX - tooltipWidth / 2 < 10) {
          const offset = ((tooltipWidth / 2 - dotCenterX + 10) / containerWidth) * 100;
          tooltip.style.left = (dotX + offset) + '%';
        }

        // Check right edge
        if (dotCenterX + tooltipWidth / 2 > containerWidth - 10) {
          const offset = ((dotCenterX + tooltipWidth / 2 - containerWidth + 10) / containerWidth) * 100;
          tooltip.style.left = (dotX - offset) + '%';
        }
      }

      debounce(func, wait) {
        clearTimeout(this.debounceTimer);
        this.debounceTimer = setTimeout(func, wait);
      }
    }

    // Initialize all hotspot displays
    function initHotspots() {
      const containers = document.querySelectorAll('.hotspot-display');
      containers.forEach(container => new HotspotDisplay(container));
    }

    // Run on DOM ready
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', initHotspots);
    } else {
      initHotspots();
    }
  })();

}